import { Injectable } from '@angular/core';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { Annonce } from '../../common/models/annonce';
import { Annulation } from './models/Annulation';
import { FormmapaServices } from './services/annulation-services/annulation.service';
import { MapaService } from '../common/services/mapa/mapa.service';
import { CommonService } from '../../common/services/common/common.service';
import { MAPA } from '../common/models/MAPA';
import { TypeAvisEnum } from '../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';

@Injectable({
	providedIn: 'root'
})
export class FormmapaANExtractorService {

	private LOG: LogService = new LogService(FormmapaANExtractorService);

	constructor(private formExtractorService: FormExtractorService, private formmapaServices: FormmapaServices,
		private mapaService: MapaService,
		private commonService: CommonService,
		private avisDataTransferService: AvisDataTransferService) {
	}

	public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {

		const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
		const annulation = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.annulationFromMAPA;

		if(stepId == 1) {
			annulation.avisInitial = this.formmapaServices.avisInitialService.getAvisInitial(controls);
		}
		if(stepId == 3) {
			annulation.description = this.formmapaServices.descriptionService.getDecription(controls, this.formExtractorService);
		}
		annulation.procedure = this.formmapaServices.procedureService.getProcedure(controls);
		if(stepId == 4) {
			annulation.infosAnnulation = controls.get('_SepSep_Annulation_SepSep_Annulation_SepAtt_infosAnnulation');
		}

		const mapa: MAPA = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa;
		if(stepId == 2) {
			mapa.organisme = this.mapaService.organismeService.getOrganisme(controls);
		}
		mapa.initialFromMAPA = null;
		mapa.attributionFromMAPA = null;
		mapa.rectificatifFromMAPA = null;
    	mapa.annulationFromMAPA = annulation;

		const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
		annonce.ann.divers = null;
		annonce.ann.mapa = mapa;
		annonce.ann.fnSimple = null;
		annonce.ann.formAD = null;
		annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
		annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
		annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    	annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		
		//TODO:
        annonce.ann.mapa.annulationFromMAPA.description.marcheTravaux = null;
		annonce.ann.mapa.annulationFromMAPA.procedure.procedureAdaptee = '';


		const avis: Avis = new Avis();
		avis.jsonSaisieFormulaire = annonce;
		avis.formulaire.code = FormsEnum[FormsEnum.MAPA_AN];
		avis.statut = StatutAvisEnum.ELABORE;
		avis.critere.typeAvis.code=TypeAvisEnum.C4_5;
		return avis;
	}
}
